<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-06-17 14:12:22
 * @Description: 流程实例详情
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
-->

<template>
  <div>
    <sticky :className="'sub-navbar'" v-if="typestring == 'defile'">
      <div class="filter-container">

        {{ postObj.customName }}
        <el-tag size="mini" style="margin-left: 10px">{{ postObj.createDate }}</el-tag>
        <el-tag size="mini">{{ postObj.activityName }}</el-tag>
        <!-- <el-button type="primary" size="small" style="margin: 0 20px;" @click="submit">提交</el-button> -->
      </div>
    </sticky>
    <div class="createPost-container">
      <el-collapse v-model="activeNames" style="padding: 0 15px; background: #fff">
        <el-collapse-item name="1">
          <el-card class="box-card" v-if="postObj.frmType == 1">
            <component v-bind:is="postObj.dbName != '' && postObj.dbName + 'Detail'" :frmData="postObj.frmData">
            </component>
          </el-card>

          <template v-else-if="postObj.frmType === 2">
            <div style="padding-right: 25px">
              <v-form-render :form-json="formJson" :globalDsv="globalDsv" :processDisabled="processdisabledd"
                :form-data="formData" :formDatashow="true" :option-data="optionData" ref="vFormRef"> </v-form-render>

            </div>
          </template>
          <template v-else-if="postObj.frmType === 3">
            <div style="padding-right: 25px">
              <v-form-render :form-json="formJson" :globalDsv="globalDsv" :processDisabled="processdisabledd"
                :form-data="formData" :formDatashow="true" :option-data="optionData" ref="detilsvFormRefdilog">
              </v-form-render>

            </div>
          </template>
          <el-card class="box-card" v-else>
            <p v-html="postObj.frmPreviewHtml"></p>
          </el-card>
        </el-collapse-item>
        <el-collapse-item title="流转记录" name="2" v-if="typestring == 'defile'">
          <span slot="title" style="font-size: 16px; font-weight: 600">流转记录</span>
          <el-timeline>
            <el-timeline-item v-for="(history, index) in histories" :key="index" :timestamp="history.createDate">
              {{ history.content }}
            </el-timeline-item>
          </el-timeline>
        </el-collapse-item>
        <el-collapse-item title="流程图" name="3" v-if="typestring == 'defile'">
          <span slot="title" style="font-size: 16px; font-weight: 600">流程图</span>
          <div style="height: 500px">
            <CreatedFlow ref="createdFlow" :form-template="currentForm" :isEdit="true" :isShowContent="isShowContent"
              :scheme-content="postObj.schemeContent"></CreatedFlow>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog :title="dialTitle" :visible.sync="dialogVisible" width="80%" ref="sel_el" append-to-body>
      <div v-if="loader">
        <v-form-render :form-json="dialFormJson" :form-data="dialFormData" :option-data="dialOptionData"
          ref="vFormRefdilog">
        </v-form-render>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import Sticky from '@/components/Sticky' // 粘性header组件
  import * as apiFlowinstances from '@/api/flowinstances'
  import CreatedFlow from '@/components/CreatedFlow'
  import * as getMaoToken from '@/utils/auth'
  export default {
    name: 'flowinstance-detail',
    inject: ['reload'],
    components: {
      Sticky,
      CreatedFlow,
    },
    props: {

      typestring: {
        type: String,
        default: 'defile'
      },
      newformdata: {},
      filterData: {}

    },
    data() {
      return {
        formJson: {}, //表单中的控件属性描述
        formData: {}, //表单数据
        optionData: {},
        processdisabledd: true,
        isShowContent: true,
        currentForm: null,
        dialogVisible: false, //弹窗显示
        dialTitle: "弹出框", //更新20230707代码
        globalDsv: {
          x_token: getMaoToken.getToken(),
          api_url: process.env.VUE_APP_BASE_API,
          sel_formdata: {}, //formdata
          sel_mainds: [], //获取弹出框单据主数据集的值
          sel_djmxds: [], //获取弹出框表格明细数据的值
          parentEL: this

        },
        postObj: {
          customName: '',
          schemeContent: '',
          createDate: '',
          activityName: '',
          code: '',
          dbName: '',
          frmType: 0,
          frmData: '',
          activityId: '',
        },
        activeNames: ['1', '2', '3'], // 展开的信息
        loading: false,
        histories: [],
      }
    },
    async created() {
      // 等待 vform 异步加载完成
      if (window.__vformReady) {
        await window.__vformReady
      }

      if (this.typestring == 'details') {
        this.postObj.frmType = 3
        let _this = this
        _this.formJson = this.newformdata
        _this.formData = this.filterData
        console.log(this.newformdata, this.filterData);
        this.processdisabledd = false //禁止表格编辑
        _this.$nextTick(function () {
          if (this.$refs.detilsvFormRefdilog) {
            this.$refs.detilsvFormRefdilog.printdisableForm()
          }
        })
      } else {
        const id = this.$route.params && this.$route.params.id
        let _this = this
        apiFlowinstances
          .get({
            id: id || this.id,
          })
          .then((response) => {
            _this.postObj = response.result
            if (_this.postObj.frmType === 2) {
              //拖动表单
              if (!response.result.frmContentData.includes('widgetList')) {
                _this.$message({
                  message: '最新版表单设计不支持v4.4及以前版本的拖动表单，新增个表单试试~~',
                  type: 'error',
                })
                return
              }
              _this.formJson = JSON.parse(response.result.frmContentData)
              _this.formData = JSON.parse(response.result.frmData)
              this.processdisabledd = false //禁止编辑
              _this.$nextTick(function () {
                if (this.$refs.vFormRef) {
                  this.$refs.vFormRef.disableForm()
                }
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })

        apiFlowinstances
          .queryHistories({
            flowInstanceId: id,
          })
          .then((response) => {
            this.histories = response.result
          })
          .catch((err) => {
            console.log(err)
          })
      }

    },
    methods: {
      po() {
        this.reload()
      },
      OpenPrintPreview(fromid, obj) {
        // console.log(fromid, obj);
        this.$emit('OpenPrintPreview', fromid, obj)
      },
      OpenPrintPage(fromid, obj) {
        // console.log(fromid, obj);
        this.$emit('OpenPrintPage', fromid, obj)
      },

      openDialog(formid, key) {
        //	this.$refs.vFormRefdilog.clearFormTemplates()
        console.log("单据唯一ID" + formid)
        this.dialogVisible = true
        var objPage1 = this;
        this.$refs.sel_el.$nextTick(() => {

          this.fetchData(formid).then(res => {
            if (res.code == 200) {
              console.log(this.$refs.vFormRefdilog)
              this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
              this.formData.con = key

              // console.log('con'+this.$refs.vFormRefdilog.getWidgetRef('con').getValue())
              this.$refs.vFormRefdilog.setFormData(this.formData)

              if (!this.myglobalDsv.parentEL) {
                this.myglobalDsv.parentEL = this
              }

              this.$refs.vFormRefdilog.globalDsv = this.globalDsv
              this.$nextTick(() => {
                this.renderObject1 = this.$refs.vFormRefdilog;
                this.$refs.vFormRefdilog.addEC('myEC', objPage1)
              })
            }
          })
        })
        this.loader = false
        setTimeout(() => {
          this.loader = true
        }, 1);
      },


      newOpenDialog(formid, filterData, okFun) {

        this.dialogVisible = true
        var objPage1 = this;
        this.$refs.sel_el.$nextTick(() => {

          this.fetchData(formid).then(res => {
            this.globalDsv.filterData = filterData;//界面上传递的数据
            this.globalDsv.okFun = okFun;//保存后的回调函数
            this.$refs.vFormRefdilog.globalDsv = this.globalDsv
            this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
            if (!this.myglobalDsv.parentEL) {
              this.myglobalDsv.parentEL = this
            }
            this.$nextTick(() => {
              this.renderObject1 = this.$refs.vFormRefdilog;
              this.$refs.vFormRefdilog.addEC('myEC', objPage1)
            })
          })
        })
        this.loader = false
        setTimeout(() => {
          this.loader = true
        }, 1);
      },
      submit() {
        console.log(this.formData);
      }
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import 'src/styles/mixin.scss';

  .createPost-container {
    position: relative;
    padding: 10px;

    .createPost-main-container {
      padding: 40px 45px 20px 50px;

      .postInfo-container {
        position: relative;
        @include clearfix;
        margin-bottom: 10px;

        .postInfo-container-item {
          float: left;
        }
      }

      .editor-container {
        min-height: 500px;
        margin: 0 0 30px;

        .editor-upload-btn-container {
          text-align: right;
          margin-right: 10px;

          .editor-upload-btn {
            display: inline-block;
          }
        }
      }
    }

    .word-counter {
      width: 40px;
      position: absolute;
      right: -10px;
      top: 0px;
    }
  }

</style>

